import {Component, OnInit} from '@angular/core';
import {UserService} from '@services/user.service';
import {Sort, MatDialog} from '@angular/material';
import {RegistrationUserDialog} from '@components/users/registration-user-dialog/registration-user-dialog.component';
import {UserDialog} from '@components/users/user-dialog/user-dialog.component';
import {DialogSharedComponent} from '@components/dialog-shared/dialog-shared.component';
import {FontAwesomeService} from "@services/font-awesome.service";
import {AdminService} from "@services/admin.service";
import {Store} from "@ngrx/store";
import {ProfileState} from "@store/reducers/profile.reducer";
import {Router} from "@angular/router";
import {LoadUser} from "@store/actions";

@Component({
  selector: 'app-users',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  users;
  progress = false;
  logged = false;
  sortedData;
  filterValue = '';
  length;
  pageSize;
  pageIndex;
  pageSizeOptions = [5, 10, 25, 50];
  sort = '';
  order = '';

  constructor(
    private userService: UserService,
    public dialog: MatDialog,
    public faService: FontAwesomeService,
    private adminService: AdminService,
    private store: Store<ProfileState>,
    private router: Router,
    ) {}

  ngOnInit() {
    this.getUsers({pageIndex: 0, pageSize: '50', filterValue: '', sort: '', order: ''});
  }

  getUsers(page) {
    this.progress = true;
    const params =  {page : page.pageIndex + 1,
        size: page.pageSize,
        filter: page.hasOwnProperty('filterValue') ? page.filterValue : this.filterValue,
        sort: page.hasOwnProperty('sort') ? page.sort : this.sort,
        order: page.hasOwnProperty('order') ? page.order : this.order};
    this.userService.getUsers(params).subscribe((users) => {
      this.users = users.data;
      this.length = users.total;
      this.pageSize = users.per_page;
      this.pageIndex = users.current_page;
      this.sortedData = this.users.slice();
      this.logged = true;
      setTimeout(() => {
        this.progress = false;
      }, 1000);

    });
  }

  openEditDialog(user) {
    const dialogRef = this.dialog.open(UserDialog, {width: '680px'});
    dialogRef.componentInstance.userDetails = user;
    dialogRef.afterClosed().subscribe(result => {
      this.getUsers({pageIndex: 0, pageSize: this.pageSize});
    });

  }

  regitsrationUser() {
    const dialogRef = this.dialog.open(RegistrationUserDialog, {width: '680px'});
    dialogRef.afterClosed().subscribe(result => {
      this.getUsers({pageIndex: 0, pageSize: this.pageSize});
    });
  }

  removeUser(user) {
    const dialogRef = this.dialog.open(DialogSharedComponent,
      {width: '450px', data: { id: user.name, bodyModalText: 'user.remove' }});
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'true') {
        this.progress = true;
        this.userService.removeUser(user.id).subscribe(() => {
          this.getUsers({pageIndex: 0, pageSize: this.pageSize});
        });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.getUsers({pageIndex: 0, pageSize: this.pageSize, filterValue: filterValue});
    this.filterValue = filterValue;
    this.pageIndex = 0;
  }
  sortData(sort: Sort) {
    this.getUsers({pageIndex: 0, pageSize: this.pageSize, sort: sort.active, order: sort.direction});
    this.sort = sort.active;
    this.order = sort.direction;
  }

  loginUser(id) {
    this.adminService.loginAsUser(id)
      .subscribe(data => {
        this.store.dispatch(new LoadUser({user: data}));
        this.router.navigate(['dashboard'])
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/user-list/user-list.component.ts